import { getIn } from '@calendly/form'

export const validateEditingFields = async ({
  fieldNames,
  setFieldTouched,
  validateForm,
}) => {
  fieldNames.forEach((fieldName) => {
    setFieldTouched(fieldName, true, false)
  })

  const errors = await validateForm()

  return fieldNames.some((fieldName) => Boolean(getIn(errors, fieldName)))
}
